export const notificationTypes = {
  ORDER_STATUS_CHANGED: "ORDER_STATUS_CHANGED",
  VERIFICATION_STATUS_CHANGED: "VERIFICATION_STATUS_CHANGED",
  SUPPORT_REQUEST_UPDATED: "SUPPORT_REQUEST_UPDATED"
};

export const maxNotifications = 5;
